import React from 'react';
import { useLiv } from '../../context/liv'; // Import useLiv to access user context

const LivquestCalviSidebarBottom = () => {
  const { user } = useLiv(); // Assuming useLiv provides user context
  return (
    <>
      <div>
        <p className="text-sm">
          {user?.last_name} {user?.first_name}
        </p>
      </div>
    </>
  );
};

export { LivquestCalviSidebarBottom };
